import React from 'react';

export const Circles: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.11093 6.88708C10.7381 8.51426 10.7381 11.1525 9.11093 12.7796C7.48374 14.4068 4.84556 14.4068 3.21838 12.7796C1.59119 11.1524 1.59119 8.51426 3.21838 6.88708C4.84556 5.25989 7.48375 5.25989 9.11093 6.88708"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7796 3.22039C14.4068 4.84758 14.4068 7.48576 12.7796 9.11294C11.1524 10.7401 8.51423 10.7401 6.88705 9.11294C5.25986 7.48576 5.25986 4.84757 6.88705 3.22039C8.51423 1.5932 11.1524 1.5932 12.7796 3.22039"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
